import { IOrganisationConfig, Organisation } from 'fitbeat.models';

const fitillionColors = {
    PRIMARY: '#FF621D',
    PRIMARY_LIGHT: '#FDA89E',
  }
// no longer exported, access via DbOrganisationRepository instead
const organisationConfig: { [key: string]: IOrganisationConfig } = {
  JuicePlus: {
    theme: {
      colors: fitillionColors,
      iconUrl: 'https://fitillion.com/juiceplusstackedlogo',
    },
    insightConfig: {
      customInsightsPostType: 'JuicePlus',
      prioritiseBeforeWorkoutSlider: true,
    },
    nutritionConfig: {
      orderMealsSupplier: 'muscleChef',
      organisationMealTag: 'Juice Plus+',
      areUsersLessActiveByDefault: true,
    },
    name: Organisation.JuicePlus,
    teams: [
      {id: `Fruit`, displayName: `Fruit`},
      {id: `Veggies`, displayName: `Veggies`},
      {id: `Berries`, displayName: `Berries`},
      {id: `Omegas`, displayName: `Omegas`},
      {id: `Complete`, displayName: `Complete`},
    ],
  },
  ImmerseGymsUK: {
    name: Organisation.ImmerseGymsUK,
    theme: {
      colors: {
        PRIMARY: '#000000',
        PRIMARY_LIGHT: '#4b4b4b',
      },
      iconUrl: 'https://fitillion.com/immersegymsuklogo',
    },
  },
  Fitillion: {
    name: Organisation.Fitillion,
    theme: {
      colors: fitillionColors,
    },
  },
  FitillionPrivate: {
    name: Organisation.FitillionPrivate,
    theme: {
      colors: fitillionColors,
    },
    nutritionConfig: {
      orderMealsSupplier: 'muscleChef',
    },
    teams: [
      {id: `Sales`, displayName: `Sales`},
      {id: `Dev`, displayName: `Software`},
      {id: `Sports`, displayName: `Sports Science`},
      {id: `Ops`, displayName: `Operations`},
    ],
  },
  Brookvale: {
    name: Organisation.Brookvale,
    theme: {
      colors: fitillionColors,
    },
    nutritionConfig: {
      orderMealsSupplier: 'muscleChef',
    },
    workoutConfig: {
      disableHomeEquipmentForUsersWithoutAccess: false,
    },
  },
  Bidvest: {
    name: Organisation.Bidvest,
    theme: {
      colors: fitillionColors,
    },
  },
  KnightFrank: {
    name: Organisation.KnightFrank,
    nutritionConfig: {
      orderMealsSupplier: 'muscleChef',
    },
    theme: {
      colors: {
        PRIMARY: '#009491',
        PRIMARY_LIGHT: '#00dcd8',
      },
      logoUrl: 'https://fitillion.com/unitewellness',
    },
  },
  GoSmartWellness: {
    name: Organisation.GoSmartWellness,
    theme: {
      colors: {
        PRIMARY: '#005A83',
        PRIMARY_LIGHT: '#E4F2FA',
      },
      logoUrl: 'https://fitillion.com/gosmarthr-1',
    },
  },
  Entelect: {
    name: Organisation.Entelect,
    theme: {
      colors: {
        PRIMARY: '#78BA6F',
        PRIMARY_LIGHT: '#83DE77',
      },
      logoUrl: 'https://fitillion.com/entelect-logo-mobile',
    },
  },
  Primedia: {
    name: Organisation.Primedia,
    theme: {
      colors: {
        PRIMARY: '#2656F6',
        PRIMARY_LIGHT: '#4D74F8',
      },
      logoUrl: 'https://fitillion.com/primedia-logo-mobile',
    },
  },
  MKWellness: {
    name: Organisation.MKWellness,
    theme: {
      colors: {
        PRIMARY: '#6F99B0',
        PRIMARY_LIGHT: '#B0C7D4',
      },
      logoUrl: 'https://fitillion.com/mk-wellness-logo/',
    },
  },
  Bryte: {
    name: Organisation.Bryte,
    theme: {
      colors: {
        PRIMARY: '#004D73',
        PRIMARY_LIGHT: '#0093DB',
      },
      logoUrl: 'https://fitillion.com/bryte-mobile-logo/',
    },
  },
  JohnsonAndJohnson: {
    name: Organisation.JohnsonAndJohnson,
    nutritionConfig: {
      orderMealsSupplier: 'muscleChef',
    },
    theme: {
      colors: {
        PRIMARY: '#eb1700',
        PRIMARY_LIGHT: '#ff6352',
      },
      logoUrl: 'https://fitillion.com/wp-content/uploads/2025/01/jnj1.svg',
    },
  },
  GrowthPoint: {
    name: Organisation.GrowthPoint,
    theme: {
      colors: fitillionColors,
    },
  },
  Test: {
    name: Organisation.Test,
    theme: {
      colors: {
        PRIMARY: '#000000',
        PRIMARY_LIGHT: '#4b4b4b',
      },
    },
  },
};

// todo: this must be used in DbOrganisationRepository only. will be removed in #2426
export function loadTheHardcodedStaticOrganisationConfig() {
  return organisationConfig;
}
